<template>
  <svg :class="svgClass" aria-hidden="true" :style="{ color: color }">
    <use :xlink:href="iconName" />
  </svg>
</template>
<script>
export default {
  name: 'SvgIcon',
  props: {
    name: { type: String, required: true },
    className: { type: String, default: '' },
    color: { type: String, default: '' }
  },
  computed: {
    iconName() {
      return `#icon-${this.name}`
    },
    svgClass() {
      return this.className ? 'svg-icon ' + this.className : 'svg-icon'
    }
  }
}
</script>

<style scoped>
.svg-icon {
  width: 1em;
  height: 1em;
  vertical-align: -0.15em;
  fill: currentColor; /* 核心：使图标颜色可随文字颜色改变 */
  overflow: hidden;
}
</style>
